import { Modal } from "flowbite-react";
import React from "react";
import profile from "../assets/images/other3.png";

const VieWDataModal = ({ productModal, setProductModal, selectedData   }) => {
  console.log(selectedData)
  return (
    <Modal
      show={productModal}
      size="2xl"
      className="dashboard-modal-main ring-0 bg-opacity-60"
      onClose={() => setProductModal(false)}
      popup
    >
      {/* <Modal.Header /> */}
      <Modal.Body className="bg-white  p-2.5 ">
        <div className="flex flex-col  font-userFont ">
          <div className=" flex justify-end ">
            <p
              onClick={() => setProductModal(false)}
              className="text-center w-6 text-white bg-black rounded-full cursor-pointer ease-in-out duration-500 transform hover:scale-95"
            >
              X
            </p>
          </div>
          <div className="flex my-auto">
            <div className="w-1/2 ">
              <img
                src={profile}
                className="w-full h-full object-contain bg-gray-200 border "
                
                alt=""
              />
            </div>

            <div className="flex flex-col m-4 w-1/2 justify-start ">
              <div className="my-4 space-y-2">
                <h1 className="text-2xl primary font-bold ">
                  {selectedData ? selectedData["Product Name"] || selectedData.productName : ""}
                </h1>
                <div className="flex space-x-4">
                  <p>
                    <s>{selectedData ? selectedData["Old Price"] || selectedData?.oldPrice : ""} лв.</s>
                  </p>
                  <p>{selectedData ? selectedData["Current Price"] || selectedData.currentPrice : ""} лв.</p>
                </div>
              </div>
              <div className="flex flex-col space-y-2 my-auto ">
                <label>Quantity:</label>
                <input
                  type="number"
                  min={1}
                  defaultValue={1}
                  className="w-3/4"
                />
              </div>
              <div className="my-4 w-full flex flex-col items-center">
                <button
                  style={{
                    background:
                      "linear-gradient(102deg, #D73E3E 20.86%, #6B2B4B 120.36%)",
                  }}
                  className={` py-2.5 w-1/2 text-white rounded-lg  cursor-not-allowed Campton hover:scale-110 ease-in-out duration-500  mb-2 `}
                >
                  Add to Favorites
                </button>
                <p className="underline primary cursor-pointer text-end mt-2 w-full">
                  View More Detail
                </p>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default VieWDataModal;
